document.querySelectorAll(".input-group-custom").forEach((item) => {
  if (item.querySelector("input").value !== "") {
    item.classList.add("active");
  } else {
    item.classList.remove("active");
  }

  item.querySelector("input").addEventListener("change blur", (event) => {
    if (event.target.value !== "") {
      item.classList.add("active");
    } else {
      item.classList.remove("active");
    }
  });

  item.querySelector("input").addEventListener("focusin", (event) => {
    item.classList.add("active");
  });
  item.querySelector("input").addEventListener("focusout", (event) => {
    if (event.target.value === "") {
      item.classList.remove("active");
    }
  });
});

const optimizedResize = (() => {
  const callbacks = [];
  let running = false;

  const resize = () => {
    if (!running) {
      running = true;

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runCallbacks);
      } else {
        setTimeout(runCallbacks, 66);
      }
    }
  };

  const runCallbacks = () => {
    callbacks.forEach((c) => c());
    running = false;
  };

  const addCallback = (callback) => callback && callbacks.push(callback);

  return {
    add: (callback) => {
      if (!callbacks.length) {
        window.addEventListener("resize", resize);
      }

      addCallback(callback);
    },
  };
})();

window.dispatchEvent(
  new CustomEvent("onOptimizedResizeReady", {
    detail: {
      resizer: optimizedResize,
    },
  })
);

const productsOnPage = document.querySelectorAll(
  ".product:not(.disabled) .product-image"
);

const swapProductImage = (image) => {
  const { nextImage } = image.dataset;
  image.dataset.nextImage = image.src;
  image.src = nextImage;
};

productsOnPage.forEach((product) => {
  const productImage = product.querySelector("img");

  if (productImage.dataset.nextImage) {
    product.onmouseenter = product.onmouseleave = () =>
      swapProductImage(productImage);
  }
});

window.location.getParam = (parameterName) => {
  if (!parameterName) return null;
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach((item) => {
      tmp = item.split("=");
      result = tmp[0] === parameterName ? decodeURIComponent(tmp[1]) : result;
    });
  return result;
};

window.dispatchEvent(
  new CustomEvent("onSearchEngineReady", {
    detail: {
      handleSearch: (value, compareWith = "") => {
        if (!value || (compareWith && value === compareWith)) return;

        const lastChar = value[value.length - 1];
        window.location.href = encodeURI(
          `/search?type=product&q=${(value += lastChar === "*" ? "" : "*")}`
        );
      },
    },
  })
);

var addUpsellItem = (product_id, variant_id) => {
  const buttonEl = document.getElementById(`ajax_cart_button_${product_id}`);
  buttonEl.classList.add("loading");
  buttonEl.blur();
  buttonEl.disabled = true;
  window.cartHandler
    .addCartItem(variant_id)
    .then((res) => {
      if (res.status === 422) {
        window.notifyHandler.notifyShow(res.message, res.description, "error");
        return;
      }
      window.notifyHandler.notifyShow("Success", "Added to cart", "success");
    })
    .finally(() => {
      buttonEl.classList.remove("loading");
      buttonEl.disabled = false;
    });
};
var getVariantIdAndAdd = (product_id) => {
  const upsellSelectEl = document.getElementById(
    `upsell-product-variant-selector__${product_id}`
  );
  addUpsellItem(product_id, upsellSelectEl.value);
};

function openBISModal(variantId, productId) {
  this.state.variantId = variantId;
  this.state.productId = productId;

  const modal = document.getElementById("bis-modal");
  modal.style.display = "block";
}

const closeBISModal = () => {
  const modal = document.getElementById("bis-modal");
  modal.style.display = "none";
};

window.BISModal = {
  state: {
    email: "",
    productId: "",
    variantId: "",
    attributes: null,
  },
  openBISModal,
  closeBISModal,
  onSubmit: function () {
    const state = this.state;
    BIS.create(state.email, state.variantId, state.productId).then(
      (res) => {
        var msg = "";
        var title = res.status == "OK" ? "Success!" : "error!";
        var status = res.status == "OK" ? "success" : "error";
        if (res.status == "OK") {
          msg = res.message;
        } else {
          for (let error in res.errors) {
            msg += res.errors[error].join();
          }
        }
        window.notifyHandler.notifyShow(title, msg, status);
        this.closeBISModal();
      }
    );
  },
};
window.addEventListener('load', () => {
  
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    console.log(anchor)
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
  
        const containerOffset = document.querySelector(this.getAttribute('href')).offsetTop - 94
        window.scrollTo({
          top: containerOffset,
          behavior: 'smooth'
        })
    });
  });
})